import React from "react";
import {
  SafeAreaView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import type RootStackParamList from "../navigation/RootStackParamList";
import ConversationStartersList from "../components/ConversationStartersList";

type Props = NativeStackScreenProps<RootStackParamList, "ConversationStarters">;

export default function ConversationStartersScreen({ navigation }: Props) {
  return (
    <SafeAreaView style={styles.root}>
      <View style={styles.content}>
        <View style={styles.header}>
          <TouchableOpacity
            onPress={() => navigation.goBack()}
            style={styles.backButton}
            accessibilityRole="button"
            accessibilityLabel="Go back"
          >
            <Ionicons name="chevron-back" size={22} color="#fff" />
            <Text style={styles.backText}>Back</Text>
          </TouchableOpacity>
        </View>

        <Text style={styles.title}>Conversation Starters</Text>
        <Text style={styles.subtitle}>
          Gentle prompts to help the conversation flow when you&#39;re not sure
          where to begin.
        </Text>

        <ConversationStartersList style={styles.list} />
      </View>
    </SafeAreaView>
  );
}

const CONTENT_MAX_WIDTH = 720;

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: "#232335",
  },
  content: {
    flex: 1,
    width: "100%",
    maxWidth: CONTENT_MAX_WIDTH,
    alignSelf: "center",
    paddingHorizontal: 24,
    paddingTop: 16,
    paddingBottom: 24,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 16,
  },
  backButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 8,
    paddingRight: 12,
  },
  backText: {
    fontSize: 16,
    color: "#fff",
    fontFamily: "Lexend",
    marginLeft: 2,
  },
  title: {
    fontSize: 24,
    fontWeight: "700",
    color: "#fff",
    fontFamily: "LexendBold",
  },
  subtitle: {
    marginTop: 6,
    marginBottom: 16,
    fontSize: 14,
    lineHeight: 20,
    color: "#DD9832",
    fontFamily: "Lexend",
  },
  list: {
    flex: 1,
  },
});
